import { OMS_ORDER_SUBSCRIPTIONS_HMAC_PATH } from '../../constants/paths';
import { apiB2B } from '../axios-client';
export var getOrderSubscriptionHMAC = function () {
    return apiB2B.get(OMS_ORDER_SUBSCRIPTIONS_HMAC_PATH);
};
